import { render, staticRenderFns } from "./PromocodeCard.vue?vue&type=template&id=59e50e94&scoped=true"
import script from "./PromocodeCard.vue?vue&type=script&lang=js"
export * from "./PromocodeCard.vue?vue&type=script&lang=js"
import style0 from "./PromocodeCard.vue?vue&type=style&index=0&id=59e50e94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e50e94",
  null
  
)

export default component.exports